export type ChatChannelStatusInfo = {
  type: 'unavailable' | 'missing' | 'deleted'
  tooltip: string
}

export type ChatChannelInfo = {
  name: string
  logo: string
  phone?: string
  title?: string
  statusInfo?: ChatChannelStatusInfo
}

export const chatFilterServiceId = 'chat'

export type ChatRatingIcon = {
  icon: string
  color: 'green' | 'red'
}
